'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@extern/ui/button';
import { Text } from '@extern/ui/text';
import { type Control, useWatch } from 'react-hook-form';
import { useCampaign } from '../_campaigns/use-campaign';
import type { GiftFormData, Recipient } from '../_utils/schema';
interface OrderSummaryProps {
  control: Control<GiftFormData>;
  isLoading?: boolean;
}
export function OrderSummary(t0) {
  const $ = _c(19);
  const {
    control,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const {
    prices
  } = useCampaign();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== control) {
    t3 = {
      control,
      name: "recipients",
      defaultValue: t2
    };
    $[1] = control;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const recipients = useWatch(t3);
  let t4;
  if ($[3] !== prices || $[4] !== recipients) {
    let t5;
    if ($[6] !== prices) {
      t5 = (sum, recipient) => {
        if (recipient.quantity) {
          return sum + prices[recipient.quantity as keyof typeof prices];
        }
        return sum;
      };
      $[6] = prices;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = recipients.reduce(t5, 0);
    $[3] = prices;
    $[4] = recipients;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const total = t4;
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text className="font-medium text-[22px] text-role-on-background leading-[28px]">Order summary</Text>;
    t6 = <div className="border-role-outline-subtle border-t border-dashed" />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text className="font-medium text-[18px] text-role-on-surface-variant leading-[24px]">Total</Text>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== total) {
    t8 = <div className="flex items-center justify-between">{t7}<Text className="font-medium text-[18px] text-role-on-background leading-[24px]">${total}</Text></div>;
    $[11] = total;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = recipients.length === 0 || total === 0 || isLoading;
  let t10;
  if ($[13] !== t9) {
    t10 = <Button appearance="tonal" className="w-full text-[16px]" color="info" disabled={t9} rounded="xl" size="sm" type="submit">Continue to checkout</Button>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Text className="text-center text-[12px] text-role-on-background-subtle">By purchasing this gift, I have read and agree to the{" "}<a className="underline hover:text-role-primary" href="https://www.extern.com/terms-of-service" rel="noreferrer" target="_blank">{"Terms & Conditions"}</a>.</Text>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t8) {
    t12 = <div className="space-y-6 rounded-3xl border border-role-outline-subtle bg-role-surface px-6 py-7">{t5}{t6}{t8}{t10}{t11}</div>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}